<template>
  <div>
    <div class="air__utils__heading">
      <h5>Comissionamento</h5>
    </div>
    <div>
      <div class="row">
        <div class="col-xl">
          <div class="card">
            <div class="card-body">
              <h4 class="mb-4">
                <strong>Filtros de Busca</strong>
              </h4>

              <a-form layout="vertical">
                <div class="row">
                  <div class="col-md">
                    <div class="ant-row ant-form-item">
                      <div class="ant-col ant-form-item-label">
                        <label title="Periodo" class>Periodo</label>
                      </div>
                      <div class="ant-col ant-form-item-control-wrapper">
                        <div class="ant-form-item-control">
                          <span class="ant-form-item-children">
                            <a-range-picker :v-model="filtrosLocal.rangeDates" :default-value="[
                              moment(moment().add(-7, 'days'), dateFormat),
                              moment(moment(), dateFormat),
                            ]" :format="dateFormat" @calendarChange="handleCalendarChange" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="sysAdminUser" class="col-xl">
                    <a-form-item label="Canal de Venda">
                      <a-select default-value="" v-model="filtrosLocal.idSaleChannel">
                        <a-select-option :value="null">
                          Selecione
                        </a-select-option>
                        <a-select-option :value="item.id" v-for="(item, index) in salechannels"
                          :key="`salechannel-${index}`">
                          {{ item.description }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                  <div v-if="sysAdminUser || saleChannelUser" class="col-md">
                    <a-form-item label="Centro de Custo">
                      <a-select default-value="" v-model="filtrosLocal.idCostCenter">
                        <a-select-option :value="null">
                          Selecione
                        </a-select-option>
                        <a-select-option :value="item.id" v-for="(item, index) in costcenters"
                          :key="`costcenter-${index}`">
                          {{ item.description }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </div>
                </div>
                <hr />
                <div class="row" v-if="!comissionedUser">
                  <div class="col-xl">
                    <div class="ant-row ant-form-item">
                      <div class="ant-col ant-form-item-label">
                        <label title="Email" class>Comissionado</label>
                      </div>
                      <div class="ant-col ant-form-item-control-wrapper">
                        <div class="ant-form-item-control">
                          <span class="ant-form-item-children">
                            <v-select label="comissioning" :filterable="false" :options="usersComission"
                              :reduce="(user) => user.id" v-model="filtrosLocal.idUser" @search="onSearchComissioning">
                              <template slot="no-options">Pesquisar Comissionado</template>
                              <template slot="option" slot-scope="option">{{
                                option.name
                                }}</template>
                              <template slot="selected-option" slot-scope="option">{{ option.name }}</template>
                            </v-select>
                          </span>
                          <!---->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-2">
                    <b-button class="col-12" @click="cleanFilter">Limpar</b-button>
                  </div>
                  <div class="col-md-2">
                    <b-button class="col-12" @click="filtrar" variant="outline-primary">Filtrar</b-button>
                  </div>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="row">
            <div>
              <h4 class="mb-4" style="padding-left: 25px">
                <strong>Indicadores </strong>
              </h4>
            </div>
          </div>

          <div class="row">
            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-success" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.managerAmount) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Gerente</div>
              </div>
            </div>

            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-success" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.coordinatorAmount) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Coordenador</div>
              </div>
            </div>

            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-success" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.supervisorAmount) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Supervisor</div>
              </div>
            </div>

            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-success" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.representativeAmount) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Representante</div>
              </div>
            </div>

            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-success" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.salesmanAmount) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Vendedor</div>
              </div>
            </div>

            <div class="col-xl">
              <div class="pt-3" :class="$style.container">
                <div class="bg-warning" :class="$style.status"></div>
                <div class="d-flex flex-nowrap align-items-center pb-3 pl-4 pr-4">
                  <div class="mr-auto">
                    <div class="
                        text-uppercase
                        font-weight-bold font-size-24
                        text-dark
                      ">
                      {{ FormatAmount(totals.Comission) }}
                    </div>
                  </div>
                </div>
                <div class="py-3 bg-gray-1 pl-4">Total</div>
              </div>
            </div>
          </div>

          <div class="row">
            <h4 class="mb-4" style="margin-top: 15px; padding-left: 25px">
              <strong>Detalhe </strong>
            </h4>
          </div>
          <hr />
          <div class="col-xl">
            <a-table :columns="columns" :dataSource="displayItens" :pagination="pagination" @change="onChangePage">
              <span slot="dtTransaction" slot-scope="text">
                {{ moment(text).format("DD/MM/YYYY HH:mm:ss") }}</span>
              <span slot="nuAmountGross" slot-scope="text">
                {{ text | money }}</span>
              <template slot="transactionStatus" slot-scope="row">
                <span v-if="row == 'Confirmado'" class="font-size-10 badge badge-success">
                  {{ row }}
                </span>
                <span v-else-if="row == 'Recusado'" class="font-size-10 badge badge-warning">
                  {{ row }}
                </span>
                <span v-else class="font-size-10 badge badge-default">
                  {{ row }}
                </span>
              </template>

              <template slot="nuAmountNet" slot-scope="row">
                {{ row.nuAmountNet | money }} |
                {{
                  (((row.nuAmountGross - row.nuAmountNet) / row.nuAmountGross) *
                    100.0)
                  | percentage
                }}
              </template>

              <span slot="paymentMethod" slot-scope="text">
                {{ getPaymentMethod(text) }}</span>
              <span slot="cardIssuer" slot-scope="text">
                <img :src="GetImageCard(text)" :alt="text" width="auto" height="38px" />
              </span>
              <span slot="cardMask" slot-scope="text"> {{ text }}</span>
              <a-table slot="expandedRowRender" slot-scope="record" :columns="innerColumns"
                :data-source="handleExpandedChanged(record)">
                <!--   <span slot="saleChannelLiquidFee" slot-scope="text">
                  {{ text | percentage }}</span
                > -->

                <template slot="totalAcquirer" slot-scope="row">
                  {{
                    ((row.totalAcquirer / row.nuAmountGross) * 100) | percentage
                  }}
                </template>

                <span slot="taxAmount" slot-scope="text">
                  {{ text | money }}</span>

                <span slot="saleChannelAmountTotal" slot-scope="row">
                  {{ (row.saleChannelAmount - row.acquirerAmount) | money }}
                </span>
                <span slot="saleChannelAmountLiquid" slot-scope="text">
                  {{ text | money }}</span>
                <span slot="platformAmount" slot-scope="text">
                  {{ text | money }}</span>

                <!-- tabela de comissão d0 canal de venda -->

                <a-table v-if="showComissioning(record)" slot="expandedRowRender" slot-scope="record"
                  :columns="commisioningColumns" pagination="{false}" :data-source="handleExpandedChanged(record)">
                  <span slot="managerAmount" slot-scope="text">
                    {{ text | money }}</span>

                  <span slot="coordinatorAmount" slot-scope="text">
                    {{ text | money }}</span>

                  <span slot="supervisorAmount" slot-scope="text">
                    {{ text | money }}</span>

                  <span slot="representativeAmount" slot-scope="text">
                    {{ text | money }}</span>

                  <span slot="salesmanAmount" slot-scope="text">
                    {{ text | money }}</span>
                  <!-- <p slot="expandedRowRender" slot-scope="record" style="margin: 0">{{record.description}}</p> -->
                </a-table>
              </a-table>
            </a-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { ElasticResource } from "@/resources/elastic/api.resource.js";
import { FormatCurrency, GetCardImagePath } from "@/utils/helpers.js";
import { get as _get, debounce as _debounce } from "lodash";
// import ExportData from "@/components/exportdata/export.vue";

const columns = [
  {
    title: "Id",
    dataIndex: "idCaptureTransaction",
    key: "idCaptureTransaction",
  },
  {
    title: "Status",
    dataIndex: "transactionStatus",
    key: "transactionStatus",
    scopedSlots: { customRender: "transactionStatus" },
  },
  {
    title: "Data",
    dataIndex: "dtTransaction",
    key: "dtTransaction",
    scopedSlots: { customRender: "dtTransaction" },
  },
  { title: "Estabelecimento", dataIndex: "merchant", key: "merchant" },
  { title: "Device", dataIndex: "deviceModel", key: "deviceModel" },
  { title: "Serial Number", dataIndex: "serialNumber", key: "serialNumber" },
  {
    title: "Valor Bruto",
    dataIndex: "nuAmountGross",
    key: "nuAmountGross",
    scopedSlots: { customRender: "nuAmountGross" },
  },
  {
    title: "Valor Líquido",
    dataIndex: "",
    key: "",
    scopedSlots: { customRender: "nuAmountNet" },
  },

  { title: "Parcelas", dataIndex: "nuInstallments", key: "nuInstallments" },
  {
    title: "Meio de Pagamento",
    dataIndex: "paymentMethod",
    key: "paymentMethod",
    scopedSlots: { customRender: "paymentMethod" },
  },
  {
    title: "Bandeira",
    dataIndex: "cardIssuer",
    key: "cardIssuer",
    scopedSlots: { customRender: "cardIssuer" },
  },
  {
    title: "Cartão",
    dataIndex: "cardMask",
    key: "cardMask",
    scopedSlots: { customRender: "cardMask" },
  },
];

const innerColumns = [
  /* {
    title: "Adquirencia",
    dataIndex: "",
    key: "",
    scopedSlots: { customRender: "totalAcquirer" },
  }, */
  {
    title: "Imposto",
    dataIndex: "taxAmount",
    key: "taxAmount",
    scopedSlots: { customRender: "taxAmount" },
  },

  {
    title: "Comissão",
    dataIndex: "",
    key: "saleChannelAmountTotal",
    scopedSlots: { customRender: "saleChannelAmountTotal" },
  },

  {
    title: "Comissão Canal de Venda",
    dataIndex: "saleChannelAmountLiquid",
    key: "saleChannelAmountLiquid",
    scopedSlots: { customRender: "saleChannelAmountLiquid" },
  },

  {
    title: "Comissão Plataforma",
    dataIndex: "platformAmount",
    key: "platformAmount",
    scopedSlots: { customRender: "platformAmount" },
  },
];

const commisioningColumns = [
  {
    title: "Gerente",
    dataIndex: "managerAmount",
    key: "managerAmount",
    scopedSlots: { customRender: "managerAmount" },
  },
  {
    title: "Coordenador",
    dataIndex: "coordinatorAmount",
    key: "coordinatorAmount",
    scopedSlots: { customRender: "coordinatorAmount" },
  },

  {
    title: "Supervisor",
    dataIndex: "supervisorAmount",
    key: "supervisorAmount",
    scopedSlots: { customRender: "supervisorAmount" },
  },

  {
    title: "Representante",
    dataIndex: "representativeAmount",
    key: "representativeAmount",
    scopedSlots: { customRender: "representativeAmount" },
  },

  {
    title: "Vendedor",
    dataIndex: "salesmanAmount",
    key: "salesmanAmount",
    scopedSlots: { customRender: "salesmanAmount" },
  },
];

export default {
  name: "TableTransaction",

  data() {
    return {
      loading: false,
      totals: {
        managerAmount: 0,
        coordinatorAmount: 0,
        supervisorAmount: 0,
        representativeAmount: 0,
        salesmanAmount: 0,
        TPV: 0,
        Transactions: 0,
        Plataform: 0,
        NetSaleChannel: 0,
        Comission: 0,
        SaleChannelTotal: 0,
        Approved: 0,
        Canceled: 0,
        Refused: 0,
        Chargeback: 0,
      },
      filtrosLocal: {
        index: 1,
        size: 25,
        idSaleChannel: null,
        idCostCenter: null,
        idUser: 0,
        rangeDates: [
          moment(moment().add(-7, "days"), "DD/MM/YYYY"),
          moment(moment(), "DD/MM/YYYY"),
        ],
      },
      itens: [],
      displayItens: [],
      salechannels: [],
      costcenters: [],
      currentRow: [],
      columns,
      innerColumns,
      commisioningColumns,
      dateFormat: "DD/MM/YYYY",
      monthFormat: "YYYY/MM",
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
      totalSize: 1,
      pagination: {
        pageSize: 25,
        total: 0,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} de Total ${total} Transações`,
      },
      usersComission: [
        {
          id: _get(this.device, "IdUser", ""),
          name: _get(this.device, "name", "Buscar Comissionado"),
        },
      ],
    };
  },

  created() {
    this.getLista();
    if (this.sysAdminUser) this.getSalechannels();
    if (this.sysAdminUser || this.saleChannelUser) this.getCostCenters();
  },

  computed: {
    getIdCostCenter() {
      try {
        return parseInt(this.$store.getters.user.costcenter);
      } catch (e) {
        return null;
      }
    },
    getIdSaleChannel() {
      try {
        return parseInt(this.$store.getters.user.salechannel);
      } catch (e) {
        return null;
      }
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },
    saleChannelUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "SaleChannel").length > 0
        );
      } catch (e) {
        return false;
      }
    },
    comissionedUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter((role) => role === "Manager" || role === "Coordinator" || role === "Supervisor" || role === "Representative" || role === "Salesman").length > 0
        );
      } catch (e) {
        return false;
      }
    },

    IdUser() {
      try {
        return this.$store.getters.user.userId;
      } catch (e) {
        return "";
      }
    }

  },

  methods: {
    getPaymentMethod(name) {
      let result = "";
      switch (name) {
        case "Debit":
          result = "Débito";
          break;
        case "Credit":
          result = "Crédito";
          break;
        case "Pix":
          result = "Pix";
          break;
      }
      return result;
    },
    FormatAmount(text) {
      return FormatCurrency(text);
    },

    handleCalendarChange(dates) {
      this.filtrosLocal.rangeDates = dates;
    },
    getSalechannels() {
      this.$api
        .get("v1/salechannel/keyvalue")
        .then((result) => {
          this.salechannels = result.data.payload;
        })
        .catch((e) => { });
    },

    getCostCenters() {
      this.$api
        .get("v1/costcenter/keyvalue")
        .then((result) => {
          this.costcenters = result.data.payload;
        })
        .catch((e) => { });
    },

    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchComissioning(search, loading) {
      loading(true);
      this.searchComissioning(loading, search, this);
    },

    searchComissioning: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/user/comissioner/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.usersComission = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        })
        .catch((e) => { });
    }, 350),

    handleExpandedChanged(record) {
      let row = [];
      row.push(record);
      return row;
    },

    showComissioning(record) {
      var visible = false;
      visible |= record.managerAmount > 0;
      visible |= record.coordinatorAmount > 0;
      visible |= record.supervisorAmount > 0;
      visible |= record.representativeAmount > 0;
      visible |= record.salesmanAmount > 0;
      return visible == 1 ? true : false;
    },

    filtrar() {
      this.totals.managerAmount = 0;
      this.totals.coordinatorAmount = 0;
      this.totals.supervisorAmount = 0;
      this.totals.representativeAmount = 0;
      this.totals.salesmanAmount = 0;
      this.totals.Comission = 0;
      this.itens = [];
      this.displayItens = [];
      this.currentPage = 1;
      this.getLista();
    },

    GetImageCard(text) {
      return GetCardImagePath(text);
    },
    moment,

    getLista() {
      if (typeof this.itens[this.filtrosLocal.index] === "undefined") {

        if (this.comissionedUser)
          this.filtrosLocal.idUser = this.IdUser;

        if (!this.sysAdminUser)
          this.filtrosLocal.idSaleChannel = this.getIdSaleChannel;

        if (!this.sysAdminUser && !this.saleChannelUser)
          this.filtrosLocal.idCostCenter = this.getIdCostCenter;

        this.loading = true;

        ElasticResource.queryComissioning(this.filtrosLocal)
          .then((result) => {
            try {
              const { hits } = result.data;
              const { aggregations } = result.data;
              const { value } = hits.total;
              this.pagination.total = hits.total.value;

              const approvedList =
                typeof aggregations.agg_terms_idTransactionStatus !== 'undefined' ?
                  aggregations.agg_terms_idTransactionStatus.buckets.filter(
                    (item) => item.key == 1
                  ) : [];

              if (approvedList.length > 0) {
                this.totals.Approved =
                  approvedList[0].agg_sum_nuAmountGross.value;
                this.totals.SaleChannelTotal =
                  approvedList[0].agg_sum_saleChannelAmountLiquid.value;
                this.totals.Plataform =
                  approvedList[0].agg_sum_platformAmount.value;

                this.totals.Comission =
                  approvedList[0].agg_sum_managerAmount.value +
                  approvedList[0].agg_sum_coordinatorAmount.value +
                  approvedList[0].agg_sum_supervisorAmount.value +
                  approvedList[0].agg_sum_representativeAmount.value +
                  approvedList[0].agg_sum_salesmanAmount.value;

                this.totals.managerAmount = approvedList[0].agg_sum_managerAmount.value;
                this.totals.coordinatorAmount = approvedList[0].agg_sum_coordinatorAmount.value;
                this.totals.supervisorAmount = approvedList[0].agg_sum_supervisorAmount.value;
                this.totals.representativeAmount = approvedList[0].agg_sum_representativeAmount.value;
                this.totals.salesmanAmount = approvedList[0].agg_sum_salesmanAmount.value;

              } else {
                // checks the idUserComission 

                if (this.filtrosLocal.idUser > 0) {
                  if (aggregations.agg_terms_idManager.buckets.length > 0
                    && aggregations.agg_terms_idManager.buckets[0].key == this.filtrosLocal.idUser) {
                    this.totals.Comission += aggregations.agg_terms_idManager.buckets[0].agg_sum_managerAmount.value;
                    this.totals.managerAmount = aggregations.agg_terms_idManager.buckets[0].agg_sum_managerAmount.value;
                  }
                  if (aggregations.agg_terms_idSupervisor.buckets.length > 0
                    && aggregations.agg_terms_idSupervisor.buckets[0].key == this.filtrosLocal.idUser) {
                    this.totals.Comission += aggregations.agg_terms_idSupervisor.buckets[0].agg_sum_supervisorAmount.value;
                    this.totals.supervisorAmount = aggregations.agg_terms_idSupervisor.buckets[0].agg_sum_supervisorAmount.value;
                  }

                  if (aggregations.agg_terms_idCoordinator.buckets.length > 0
                    && aggregations.agg_terms_idCoordinator.buckets[0].key == this.filtrosLocal.idUser) {
                    this.totals.Comission += aggregations.agg_terms_idCoordinator.buckets[0].agg_sum_coordinatorAmount.value;
                    this.totals.coordinatorAmount = aggregations.agg_terms_idCoordinator.buckets[0].agg_sum_coordinatorAmount.value;
                  }

                  if (aggregations.agg_terms_idRepresentative.buckets.length > 0
                    && aggregations.agg_terms_idRepresentative.buckets[0].key == this.filtrosLocal.idUser) {
                    this.totals.Comission += aggregations.agg_terms_idRepresentative.buckets[0].agg_sum_representativeAmount.value;
                    this.totals.representativeAmount = aggregations.agg_terms_idRepresentative.buckets[0].agg_sum_representativeAmount.value;
                  }

                  if (aggregations.agg_terms_idSalesman.buckets.length > 0
                    && aggregations.agg_terms_idSalesman.buckets[0].key == this.filtrosLocal.idUser) {
                    this.totals.Comission += aggregations.agg_terms_idSalesman.buckets[0].agg_sum_salesmanAmount.value;
                    this.totals.salesmanAmount = aggregations.agg_terms_idSalesman.buckets[0].agg_sum_salesmanAmount.value;
                  }

                }


              }

              this.itens[this.filtrosLocal.index] = hits.hits.map((itens) => {
                let { _source } = itens;
                return { ..._source, key: _source.id };
              });
              this.displayItens = this.itens[this.filtrosLocal.index].flat();
              this.totalRows = value;
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: e,
                  },
                },
              };
            }
          })
          .catch((e) => {
            this.loading = false;
          });
      } else {
        this.displayItens = this.itens[this.filtrosLocal.index].flat();
      }
    },

    cleanFilter() {
      this.filtrosLocal.index = 1;
      this.filtrosLocal.size = 50;
      this.filtrosLocal.idUser = null;
      this.filtrosLocal.idSaleChannel = null;
      this.filtrosLocal.idCostCenter = null;
    },

    onChangePage(pagging) {
      this.filtrosLocal.index = pagging.current;
      this.getLista();
    },
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
